import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import React from "react"
import doenerCase from "scripts/doenerCase"

export const AuthorLink = ({ author, ressort }) => {
  if (!!author.strapi_data) {
    const author_slug = doenerCase(author?.strapi_data?.name)
    return (
      <div className="level-item mr-2">
        <Link to={`/ueber-uns/redaktion/${author_slug}`}>
          {!!author.strapi_data?.image ? (
            <GatsbyImage
              image={
                author.strapi_data.image.localFile.childImageSharp.thumbnail
              }
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                border: "1px solid white",
              }}
              imgStyle={{ borderRadius: "100%" }}
              alt={author.name}
              title={author.name}
              className="mx-1"
            />
          ) : (
            <div
              x-bi-data-nosnippet="true"
              className={`has-background-${ressort} has-text-weight-bold mx-1`}
              style={{
                display: "flex",
                height: 32,
                width: 32,
                borderRadius: "100%",
                color: "white",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid white",
              }}
            >
              {author.strapi_data.pseudonyms?.strapi_json_value?.[0].charAt(0)}
            </div>
          )}
        </Link>
        <Link className="link" to={`/ueber-uns/redaktion/${author_slug}`}>
          {author.strapi_data.pseudonyms?.strapi_json_value?.[0] || author.name}
        </Link>
      </div>
    )
  }
  return (
    <div className="level-item mr-2">
      <div
        className={`has-background-${ressort} has-text-weight-bold mx-1`}
        style={{
          display: "flex",
          height: 32,
          width: 32,
          borderRadius: "100%",
          color: "white",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid white",
        }}
      >
        {author.name.charAt(0)}
      </div>
      {author.name}
    </div>
  )
}
